module.exports = __webpack_public_path__ + "static/16-405e8d8a3cb110b02f89db9b132f7aa3.png";